export default {
  modalDescription: {
    id: 'shipping_zip_modal_description',
    defaultMessage:
      'Delivery options and speed may vary depending on location.',
  },
  modalSubmitCta: {
    id: 'shipping_zip_modal_submit_cta',
    defaultMessage: 'Update',
  },
  postalCodeLabel: {
    id: 'address_fields_postal_code',
    defaultMessage: 'ZIP code',
  },
  shipToLabel: {
    id: 'shipping_zip_ship_to_postal_code',
    defaultMessage: 'Ship to {postalCode, html}',
  },
  updateLabel: {
    id: 'shipping_zip_update_label',
    defaultMessage: 'Update ZIP code',
  },
  switchCountryLink: {
    id: 'shipping_zip_modal_switch_country_link',
    defaultMessage: 'Change country',
  },
}
